import { render } from "./schedule.vue?vue&type=template&id=7227f804&scoped=true"
import script from "./schedule.vue?vue&type=script&lang=js"
export * from "./schedule.vue?vue&type=script&lang=js"

import "./schedule.vue?vue&type=style&index=0&id=7227f804&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7227f804"]])

export default __exports__